module.exports = __webpack_public_path__ + "static/media/8.3d1f1a79.svg";